exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-outline-grey[data-v-96d65228]{color:#aaa;border-color:#aaa}.btn-outline-grey:not(:disabled):not(.disabled).active[data-v-96d65228],.btn-outline-grey[data-v-96d65228]:not(:disabled):not(.disabled):active,.show>.btn-outline-grey[data-v-96d65228]{color:#fff;background-color:#aaa;border-color:#aaa}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-96d65228","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/upload/upload-button.vue
// module id = 1469
// module chunks = 0